{
  "version": 1,
  "asset_id": "fa5f36b7-2c1e-47df-923a-2670a6731646",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/fa5f36b7-2c1e-47df-923a-2670a6731646/ai-search-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/fa5f36b7-2c1e-47df-923a-2670a6731646/ai-search-1280.avif",
  "original_filename": "ai-search-1280.avif",
  "size": 40435,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:45Z"
}
